import axios from "axios";
import { AccountInformation } from "../../api-types/account-information";
import { ACCOUNT_INFORMATION_URL } from "../utils";

export const updateAccountInformation = async (
  accountInformation: Partial<AccountInformation>
) => {
  return await axios.patch(ACCOUNT_INFORMATION_URL, accountInformation);
};
